// Endereços oficiais fixos das redes do AAAviation.
// O canal do YouTube é usado no banner da home e no rodapé.
// (O mesmo endereço aparece no JSON-LD "sameAs" do index.html.)
export const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@aaaviationbr';

// Abre o canal já com a caixa de confirmação de inscrição do YouTube.
export const YOUTUBE_SUBSCRIBE_URL = `${YOUTUBE_CHANNEL_URL}?sub_confirmation=1`;

export const YOUTUBE_HANDLE = '@aaaviationbr';
